<script lang="ts">
    import {onMount} from 'svelte';
    import {dyData} from 'general/store';

    import s from './style.module.css';

    let time = 60;

    onMount(() => {
        const timeoutId = setInterval(() => {
            time = time - 1;

            if (time === 0) {
                clearInterval(timeoutId);
            }
        }, 1000);

        return () => clearInterval(timeoutId);
    });
</script>

<div class={s.wrapper} style="margin-top: {$dyData.counterDown?.marginTop || 0}">
    <span class={s.time}>00</span>
    <span class={s.divider}>:</span>
    <span class={s.time}>{time >= 10 ? time : `0${time}`}</span>
</div>
